import { render, staticRenderFns } from "./FormPopupItem.vue?vue&type=template&id=5374e3fb&scoped=true"
import script from "./FormPopupItem.vue?vue&type=script&lang=js"
export * from "./FormPopupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374e3fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5374e3fb')) {
      api.createRecord('5374e3fb', component.options)
    } else {
      api.reload('5374e3fb', component.options)
    }
    module.hot.accept("./FormPopupItem.vue?vue&type=template&id=5374e3fb&scoped=true", function () {
      api.rerender('5374e3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormPopupItem.vue"
export default component.exports